<template>
  <v-select
    class="vue-select-custom"
    :options="options"
    :error="error"
    :taggable="taggable"
    :value="value"
    :disabled="disabled"
    :clearable="isClearable"
    @input="$emit('input', $event)"
    @search="$emit('search', $event)"
    :placeholder="placeholder"
    :selectable="option => !option.disable"
  >
    <template slot="selected-option" slot-scope="option">
      <template v-if="keyOpt === 'kode_dokter_bpjs'">
        {{ option.id }}
      </template>
      <template v-else-if="keyOpt === 'kode_kfa'">
        <div class="no-overflow" ref="selected_option_obat_kfa_div">
          {{ option.label }}
        </div>
      </template>
      <template v-else-if="option.is_promo">
        {{ option.label }}
        <span style="color: white;"> -</span>
        <img src="@/assets/img/sale.jpeg" class="sale-img" alt="" />
      </template>
      <template v-else>
        {{ option.label }}
      </template>
    </template>
  </v-select>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "v-select": () => import("vue-select")
  },
  props: {
    error: Boolean,
    isClearable: {
      type: Boolean,
      default: false
    },
    keyOpt: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    taggable: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    selectable: {
      type: Function,
      default: option => true
    }
  },
  watch: {},
  methods: {
    inputEvent($event) {
      // console.log($event)
    }
  }
};
</script>

<style lang="scss">
.v-select {
  &.vue-select-custom {
    & > .vs__dropdown-toggle {
      min-height: 41.75px !important;
    }

    &.error {
      & > .vs__dropdown-toggle {
        border-color: red;
      }
    }
  }
}

.promo-text {
  font-weight: bold;
  color: white;
  background-color: red;
  padding: 1px;
  text-align: right !important;
  // transform: skew(-20deg);
}

.sale-img {
  width: 60px;
}
</style>
